import React from "react";
import { IconProps } from "./IconProps";

const ShareNetworkIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.75 4.375C11.75 3.27043 12.6454 2.375 13.75 2.375C14.8546 2.375 15.75 3.27043 15.75 4.375C15.75 5.47957 14.8546 6.375 13.75 6.375C13.0534 6.375 12.44 6.01889 12.0819 5.4788C12.0776 5.47119 12.073 5.46365 12.0682 5.45619C12.0633 5.44851 12.0581 5.441 12.0529 5.43368C11.8609 5.12665 11.75 4.76378 11.75 4.375ZM10.9907 5.55443C10.8358 5.1924 10.75 4.79372 10.75 4.375C10.75 2.71815 12.0931 1.375 13.75 1.375C15.4069 1.375 16.75 2.71815 16.75 4.375C16.75 6.03185 15.4069 7.375 13.75 7.375C12.8713 7.375 12.0808 6.99721 11.5321 6.39519L7.75925 8.82052C7.91421 9.18257 8 9.58126 8 10C8 10.4187 7.91421 10.8174 7.75925 11.1795L11.5321 13.6048C12.0808 13.0028 12.8713 12.625 13.75 12.625C15.4069 12.625 16.75 13.9681 16.75 15.625C16.75 17.2819 15.4069 18.625 13.75 18.625C12.0931 18.625 10.75 17.2819 10.75 15.625C10.75 15.2063 10.8358 14.8076 10.9907 14.4456L7.21783 12.0202C6.66916 12.6222 5.8787 13 5 13C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7C5.8787 7 6.66916 7.37777 7.21783 7.97977L10.9907 5.55443ZM12.0682 14.5438C12.0633 14.5515 12.0582 14.559 12.0529 14.5663C11.8609 14.8733 11.75 15.2362 11.75 15.625C11.75 16.7296 12.6454 17.625 13.75 17.625C14.8546 17.625 15.75 16.7296 15.75 15.625C15.75 14.5204 14.8546 13.625 13.75 13.625C13.0534 13.625 12.44 13.9811 12.0819 14.5212C12.0776 14.5288 12.073 14.5364 12.0682 14.5438ZM6.66739 8.89515C6.30918 8.35565 5.69612 8 5 8C3.89543 8 3 8.89543 3 10C3 11.1046 3.89543 12 5 12C5.69612 12 6.30918 11.6444 6.66739 11.1048C6.67191 11.0969 6.67669 11.089 6.6817 11.0812C6.68686 11.0732 6.69222 11.0653 6.69775 11.0577C6.88931 10.7509 7 10.3884 7 10C7 9.61164 6.88931 9.24913 6.69775 8.94231C6.69222 8.93467 6.68686 8.92684 6.6817 8.91881C6.67669 8.91101 6.67192 8.90312 6.66739 8.89515Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_547_3669)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.75 7C18.75 5.20507 20.2051 3.75 22 3.75C23.7949 3.75 25.25 5.20507 25.25 7C25.25 8.79493 23.7949 10.25 22 10.25C20.868 10.25 19.8712 9.67125 19.2892 8.7935C19.2823 8.78117 19.2749 8.76898 19.2672 8.75692C19.2592 8.74451 19.2509 8.73241 19.2423 8.72063C18.9303 8.22164 18.75 7.63188 18.75 7ZM17.648 8.9062C17.392 8.32273 17.25 7.67795 17.25 7C17.25 4.37665 19.3766 2.25 22 2.25C24.6234 2.25 26.75 4.37665 26.75 7C26.75 9.62335 24.6234 11.75 22 11.75C20.5935 11.75 19.3298 11.1387 18.4601 10.1673L12.352 14.0938C12.608 14.6773 12.75 15.322 12.75 16C12.75 16.6779 12.608 17.3227 12.3521 17.9062L18.4601 21.8326C19.3299 20.8613 20.5935 20.25 22 20.25C24.6234 20.25 26.75 22.3766 26.75 25C26.75 27.6234 24.6234 29.75 22 29.75C19.3766 29.75 17.25 27.6234 17.25 25C17.25 24.322 17.392 23.6772 17.648 23.0938L11.5399 19.1673C10.6702 20.1387 9.40648 20.75 8 20.75C5.37665 20.75 3.25 18.6234 3.25 16C3.25 13.3766 5.37665 11.25 8 11.25C9.40647 11.25 10.6702 11.8613 11.5399 12.8327L17.648 8.9062ZM19.2545 23.2621C19.2506 23.2678 19.2466 23.2734 19.2426 23.279C18.9304 23.7781 18.75 24.368 18.75 25C18.75 26.7949 20.2051 28.25 22 28.25C23.7949 28.25 25.25 26.7949 25.25 25C25.25 23.2051 23.7949 21.75 22 21.75C20.8679 21.75 19.871 22.3289 19.2891 23.2068C19.2821 23.219 19.2748 23.2311 19.2672 23.243C19.263 23.2495 19.2588 23.2558 19.2545 23.2621ZM10.7112 14.2072C10.1293 13.329 9.13229 12.75 8 12.75C6.20507 12.75 4.75 14.2051 4.75 16C4.75 17.7949 6.20507 19.25 8 19.25C9.13216 19.25 10.1291 18.6711 10.711 17.7931C10.7179 17.7809 10.7252 17.7689 10.7329 17.7569C10.7408 17.7446 10.749 17.7327 10.7574 17.721C11.0696 17.2219 11.25 16.632 11.25 16C11.25 15.3678 11.0695 14.7778 10.7572 14.2786C10.7488 14.2671 10.7407 14.2552 10.7329 14.243C10.7253 14.2312 10.718 14.2192 10.7112 14.2072Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath>
              <rect width="32" height="32" fill={color} />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default ShareNetworkIcon;
